function section_has_table_content(section) {
  return section.table?.rows?.length > 0;
}

function section_has_description_content(section) {
  return (section.descriptions || []).some(desc => desc?.trim().length > 0);
}

function section_has_content(section) {
  return section_has_table_content(section) || section_has_description_content(section);
}

const computed = {
    completion_percent() {
      const sections = this.form_detail.sections || [];
      if (!sections.length) return 0;
      const sectionsWithContent = sections.filter(section_has_content);
      return Math.round((sectionsWithContent.length / sections.length) * 100);
    },

    drawer_created_date() {
      return this.profileMeta?.date_created || this.profileMeta?.created_at || this.profileMeta?.created || '';
    },

    drawer_department() {
      return this.profileMeta?.department || this.extract_section_text(['branch', 'component']) || 'DWYPD';
    },

    drawer_grade() {
      const salary_level = this.extract_section_text(['salary level', 'post/salary level', 'grade']);
      if (!salary_level) return '';
      return salary_level.toLowerCase().includes('grade') ? salary_level : `Grade ${salary_level}`;
    },

    drawer_salary_range() {
      return this.profileMeta?.salary_range || this.extract_section_text(['salary range', 'remuneration']) || 'Not specified';
    },

    drawer_adverts_count() {
      return this.as_count(this.profileMeta?.adverts_count ?? this.profileMeta?.advert_count ?? this.profileMeta?.job_adverts_count);
    },

    drawer_applicants_count() {
      const submitted_count = this.get_submitted_count(this.profileMeta);
      if (submitted_count !== null) return submitted_count;
      return this.drawer_applicants.length;
    },

    drawer_shortlisted_count() {
      return this.as_count(this.profileMeta?.shortlisted_count ?? this.profileMeta?.shortlist_count);
    },

    drawer_adverts() {
      return Array.isArray(this.profileMeta?.adverts) ? this.profileMeta.adverts : [];
    },

    drawer_applicants() {
      const applicants = Array.isArray(this.profileMeta?.applicants) ? this.profileMeta.applicants : [];
      const submitted_applicants = applicants.filter((applicant) => this.is_submitted_applicant(applicant));
      return submitted_applicants.length ? submitted_applicants : applicants;
    },

    drawer_qualified_count() {
      return this.drawer_applicants.filter((applicant) => this.drawer_applicant_bucket(applicant) === 'qualified').length;
    },

    drawer_partial_count() {
      return this.drawer_applicants.filter((applicant) => this.drawer_applicant_bucket(applicant) === 'partial').length;
    },

    drawer_unqualified_count() {
      return this.drawer_applicants.filter((applicant) => this.drawer_applicant_bucket(applicant) === 'unqualified').length;
    },

    drawer_description() {
      return this.extract_section_text(['job purpose', 'description']) || this.fallback_profile_description_text;
    },

    drawer_requirements() {
      return this.extract_section_text(['requirements', 'minimum requirements', 'competencies'])
        || 'Requirements not captured yet.';
    },

    drawer_key_duties() {
      return this.extract_section_text(['key duties', 'main functions', 'responsibilities'])
        || 'Key duties not captured yet.';
    },

    drawer_key_duties_list() {
      const section_items = this.extract_section_list(['key duties', 'main functions', 'responsibilities']);
      if (section_items.length) {
        return section_items;
      }
      return [];
    },

    fallback_profile_description_text() {
      return this.strip_html_tags(this.form_detail.description || '');
    }
};

export default computed;

